import o from "./banjian.vue2.js";
import "./banjian.vue3.js";
import a from "../../../../_virtual/_plugin-vue_export-helper.js";
const p = /* @__PURE__ */ a(o, [["__scopeId", "data-v-b72d802a"]]);
export {
  p as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/banjian/banjian.vue.js
// module id = 1199
// module chunks = 41